const GlobalState = { count: 0, loading: false, apiData: null, error: null };
export default GlobalState;
